import { getStoryBySlug } from '@cinch-nx/data-storyblok'
import {
  setTag,
  tagError,
  getTraceId,
  traceFunction,
} from '@core/datadog-server'
import type { GetStaticPropsContext, InferGetStaticPropsType } from 'next'
import { CustomerReviewsPageStoryContent } from './types/customer-reviews-page'

export async function getStaticPropsfn({
  preview = false,
}: GetStaticPropsContext) {
  const ddMeta = {
    traceId: getTraceId(),
    traceTime: Date.now(),
  }
  try {
    const story = await getStoryBySlug<CustomerReviewsPageStoryContent>(
      'customer-reviews',
      {
        version: preview ? 'draft' : 'published',
      },
    )

    if (!story) {
      throw new Error('Customer review story not found')
    }

    const HeroProps = story.content?.Hero?.[0]

    setTag('response.code', 200)

    return {
      props: {
        ddMeta,
        story,
        preview,
        generatedAt: Date.now(),
        layoutProps: {
          heroProps: HeroProps,
          showBorderRadius: true,
        },
      },
      revalidate: 300, // In seconds
    }
  } catch (error) {
    console.error(error)

    if (typeof error === 'string' || error instanceof Error) {
      tagError(error)
    }

    return {
      notFound: true,
      props: {
        ddMeta,
      },
      revalidate: 30,
    }
  }
}

export type CustomerReviewsProps = InferGetStaticPropsType<
  typeof getStaticProps
>

export const getStaticProps = traceFunction(
  'customer-reviews.getStaticProps',
  getStaticPropsfn,
)
